import { type Project, type ProjectProps, mkProject } from './projectsTypes';

export function transformProjectsToRequestData(project: Project | ProjectProps) {
  return {
    id: project.id,
    clientId: project.clientId,
    createdAt: project.createdAt,
    name: project.name,
    description: project.description,
    status: project.status,
    customerId: project.customerId,
    businessId: project.businessId,
    dueOn: project.dueOn === null ? '1970-01-01' : project.dueOn,
    completedOn: project.completedOn,
    isDeleted: project.isDeleted,
  };
}

export function transformResponseToProjects(response?: { data?: { resources?: ProjectProps[] } } | null) {
  return response?.data?.resources?.map((data) =>
    mkProject({
      id: data?.id,
      clientId: data?.clientId,
      createdAt: data?.createdAt,
      name: data?.name,
      description: data?.description,
      status: data?.status,
      customerId: data?.customerId,
      businessId: data?.businessId,
      dueOn: data?.dueOn,
      completedOn: data?.completedOn,
      isDeleted: data?.isDeleted,
    }),
  );
}
